// extracted by mini-css-extract-plugin
export default {"cls1":"VeloLogoPage-Card_cls1__cgOlg","cls2":"VeloLogoPage-Card_cls2__o9xQE VeloLogoPage-Card_cls1__cgOlg"};